/*
 *
 * NexiClub Actions
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-Jul-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_SAVE_CONSENT: '@@NexiClub/save_consent',
  DO_UPDATE_CONSENT: '@@NexiClub/update_consent',
  DO_SAVE_LOCAL_CONSENT: '@@NexiClub/save_local_consent',
  // @generator action:route:type
  ...createRequestTypes('@@NexiClub', 'SAVE_CONSENT'),
  ...createRequestTypes('@@NexiClub', 'UPDATE_CONSENT')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request

/** @action request
 * * Insert a description
 * @name saveConsent
 * @return {object} - The action object
 */
export const saveConsent = new MakeRequest('NexiClub', 'save_consent')

/** @action request
 * * Insert a description
 * @name saveConsent
 * @return {object} - The action object
 */
export const updateConsent = new MakeRequest('NexiClub', 'update_consent')

/** @action
 * * Insert a description
 * @name SaveConsent
 * @return {object} - The payload object
 */
export const doSaveConsent = (consent, url) => createAction(actionTypes.DO_SAVE_CONSENT, { consent, url })

/** @action
 * * Insert a description
 * @name SaveConsent
 * @return {object} - The payload object
 */
export const doUpdateConsents = payload => createAction(actionTypes.DO_UPDATE_CONSENT, { payload })

/** @action
 * * Insert a description
 * @name SaveLocalConsent
 * @return {object} - The payload object
 */
export const doSaveLocalConsent = payload => createAction(actionTypes.DO_SAVE_LOCAL_CONSENT, { payload })

// @generator action:route
